module.exports = __webpack_public_path__ + "img/thankyou.29111a63.svg";